import { getCourseFileObjectKey } from "./signedCourseFileUrl";

/**
 * @typedef {{ nombre?: string, storageKey?: string, url?: string }} CourseMaterialArchivoRef
 */

/**
 * @param {string | CourseMaterialArchivoRef | null | undefined} input
 * @returns {string[]}
 */
export function collectCourseMaterialPathHints(input) {
  if (input == null) {
    return [];
  }
  if (typeof input === "string") {
    const trimmed = input.trim();
    return trimmed ? [trimmed] : [];
  }
  if (typeof input !== "object") {
    return [];
  }

  /** @type {CourseMaterialArchivoRef} */
  const archivo = input;
  const hints = [];
  for (const field of ["storageKey", "nombre", "url"]) {
    const value = archivo[field];
    if (typeof value === "string" && value.trim() !== "") {
      hints.push(value.trim());
    }
  }

  const objectKey = getCourseFileObjectKey(archivo);
  if (objectKey && !hints.includes(objectKey)) {
    hints.push(objectKey);
  }

  return hints;
}

/**
 * @param {string[]} hints
 * @param {string[]} extensions
 * @returns {boolean}
 */
function pathHintsMatchExtension(hints, extensions) {
  return hints.some((hint) => {
    const lower = hint.toLowerCase().split("?")[0].split("#")[0];
    return extensions.some((ext) => lower.endsWith(ext));
  });
}

/**
 * @param {string | CourseMaterialArchivoRef | null | undefined} input
 * @returns {boolean}
 */
export function isPdfCourseMaterial(input) {
  return pathHintsMatchExtension(collectCourseMaterialPathHints(input), [".pdf"]);
}

/**
 * @param {string | CourseMaterialArchivoRef | null | undefined} input
 * @returns {boolean}
 */
export function isVideoCourseMaterial(input) {
  return pathHintsMatchExtension(collectCourseMaterialPathHints(input), [
    ".mp4",
    ".webm",
    ".mov",
  ]);
}

/**
 * @param {string | CourseMaterialArchivoRef | null | undefined} input
 * @returns {boolean}
 */
export function isAudioCourseMaterial(input) {
  return pathHintsMatchExtension(collectCourseMaterialPathHints(input), [".mp3", ".wav"]);
}

/**
 * @param {string | CourseMaterialArchivoRef | null | undefined} input
 * @returns {boolean}
 */
export function isSpreadsheetCourseMaterial(input) {
  return pathHintsMatchExtension(collectCourseMaterialPathHints(input), [".xls", ".xlsx"]);
}
